const FlexibleMap = () => {
  const allMaps = document.querySelectorAll('.map');

  allMaps.forEach((mapElement) => {
    const tab = mapElement.parentElement.parentElement.parentElement;

    $(mapElement)
      .find('.map__modal-close')
      .click(() => {
        $(mapElement).find('.map__modal').removeClass('map__modal--active');
      });

    const googleMapContainer = mapElement.querySelector('.map__map');
    const googleMap = new google.maps.Map(googleMapContainer, {
      zoom: 10,
      center: {
        lat: 0,
        lng: 0,
      },
      styles: getStyles(),
      streetViewControl: false, // This disables the Street View control
    });

    const mapLocations = mapElement.querySelectorAll('.map__location');

    const bounds = new google.maps.LatLngBounds();

    mapLocations.forEach((location) => {
      let marker;
      marker = new google.maps.Marker({
        position: {
          lat: parseFloat(location.dataset.lat),
          lng: parseFloat(location.dataset.lng),
        },
        map: googleMap,
        icon: getIconStyles(location.dataset.type, location.dataset.goldcard),
      });

      const markerLatLng = new google.maps.LatLng(
        marker.position.lat(),
        marker.position.lng()
      );

      bounds.extend(markerLatLng);

      marker.addListener('click', () => {
        const modal = $(mapElement).find('.map__modal')[0];
        const isActive = modal.classList.contains('map__modal--active');
        const modalTitle = $(modal).find('.map__modal-title')[0];
        const modalAddress = $(modal).find('.map__modal-address')[0];
        const modalImage = $(modal).find('.map__modal-image')[0];

        modal.classList.remove('map__modal--active');

        const renderContent = () => {
          modalImage.style.backgroundImage = `url(${location.dataset.image})`;
          modalTitle.innerHTML = location.dataset.title;
          modalAddress.innerHTML = location.dataset.address;
          modal.classList.add('map__modal--active');
        };

        if (isActive) {
          setTimeout(() => {
            renderContent();
          }, 400);
        } else {
          renderContent();
        }
      });
    });

    googleMap.fitBounds(bounds);

    const o = new MutationObserver(() => {
      googleMap.fitBounds(bounds);
    });

    o.observe(tab, { attributes: true, attributeFilter: ['style'] });
  });
};

const getStyles = () => [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [
      {
        color: '#e9e9e9',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 17,
      },
    ],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 29,
      },
      {
        weight: 0.2,
      },
    ],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 18,
      },
    ],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f5f5f5',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [
      {
        color: '#dedede',
      },
      {
        lightness: 21,
      },
    ],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [
      {
        visibility: 'on',
      },
      {
        color: '#ffffff',
      },
      {
        lightness: 16,
      },
    ],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [
      {
        saturation: 36,
      },
      {
        color: '#333333',
      },
      {
        lightness: 40,
      },
    ],
  },
  {
    elementType: 'labels.icon',
    stylers: [
      {
        visibility: 'off',
      },
    ],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [
      {
        color: '#f2f2f2',
      },
      {
        lightness: 19,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 20,
      },
    ],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [
      {
        color: '#fefefe',
      },
      {
        lightness: 17,
      },
      {
        weight: 1.2,
      },
    ],
  },
];

const getIconStyles = (type, goldCard) => {

  const defaultColour = '#A2A39A';
  const goldCardColour = '#998152';

  const color = goldCard ? goldCardColour : defaultColour;

  switch (type) {
    case 'development':
      return {
        path: 'M31.827 0c23.569 0 38.838 24.897 28.547 45.81C55.396 56.43 38.796 72.366 31.827 80 24.524 71.7 8.924 57.097 3.611 46.14-7.342 25.56 7.927 0 31.827 0zm-.4 23C28.58 23 27 24.748 27 27.71c0 2.227.902 3.806 3.638 6.062 2.284 1.89 3.045 3.045 3.045 4.878 0 1.805-.874 2.65-2.312 2.65-1.41 0-2.284-.845-2.284-2.622V37.41H27v1.1c0 3.046 1.523 4.794 4.399 4.794 2.876 0 4.484-1.748 4.484-4.822 0-2.397-.875-3.976-3.582-6.232-2.34-1.917-3.13-3.045-3.13-4.68 0-1.72.846-2.567 2.256-2.567 1.438 0 2.256.846 2.256 2.623v.93h2.087v-.79c0-3.017-1.495-4.765-4.343-4.765z',
        fillColor: '#2A312E',
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'food':
      return {
        path: 'M39.6253001,19.7893357 C39.4061361,31.2154218 29.2992923,42.4200896 20.9495179,49.6697849 C20.2900721,50.1100717 19.4114622,50.1100717 18.7520164,49.6697849 C9.96391393,41.9792568 -1.02183932,29.895929 0.0762341601,17.8105974 L0.0780876617,17.8126012 C1.17586157,8.1458388 9.30652199,0.455810823 19.192198,0.0154789496 C30.3968658,-0.424802829 39.6253001,8.58416689 39.6253001,19.7893357 Z M25.4570181,11 C22.5962186,11.3162592 20.8000848,20.7601439 24.3135906,21.9039572 L24.3135906,21.9039572 L23.6759881,29.3318133 L23.6844775,29.4976781 C23.7231696,29.8817674 23.8927726,30.2423402 24.1665135,30.5160639 C24.4785137,30.828891 24.9018772,31.0033341 25.3422379,31 C25.7809011,31.0016209 26.2017183,30.8263038 26.5128697,30.5134899 C26.8231723,30.2006625 26.9991512,29.7752582 27,29.3318133 L27,29.3318133 L26.4304299,21.8997331 L26.5264427,21.7721706 C26.704854,21.5083376 26.8007187,21.1945403 26.7985362,20.8718852 L26.7985362,20.8718852 L26.7986122,12.3577695 C26.7647151,11.631577 26.1899482,11.036402 25.4570181,11 Z M13.5109264,11.0151562 L13.3961593,11.0151562 L13.3164083,11.0233055 C13.1360335,11.0607046 13,11.2223794 13,11.4156339 L13,11.4156339 L13,18.7471272 L13.0064538,18.878914 C13.0704844,19.5291423 13.6033265,20.0408995 14.2624516,20.0594213 L14.2624516,20.0594213 L15.097274,20.0594213 L14.286239,29.5317969 L14.3029009,29.673681 C14.4317738,30.465504 15.1370793,31.0420003 15.944001,30.9876232 C16.7983888,31.0452033 17.5388451,30.395498 17.6017631,29.5317969 L17.6017631,29.5317969 L16.7830891,20.0594213 L17.6179116,20.0594213 L17.747302,20.0486395 C18.3847823,19.963101 18.8726494,19.4110033 18.8718556,18.7471272 L18.8718556,18.7471272 L18.8718556,11.418934 L18.8685173,11.4193102 L18.8608394,11.3411716 C18.8456165,11.2645097 18.8081571,11.193285 18.7520483,11.136558 C18.6780875,11.061791 18.5777713,11.0196796 18.472345,11.0196796 L18.472345,11.0196796 L18.3575779,11.0196796 L18.2750064,11.0233026 C18.1660267,11.0369705 18.0629231,11.0855099 17.9826597,11.1631985 C17.8823435,11.2603116 17.8245355,11.3952393 17.8236846,11.5353174 L17.8236846,11.5353174 L17.8236846,16.1519317 L17.816079,16.2518114 C17.7773999,16.5135687 17.5945256,16.7345159 17.3391006,16.816241 C17.0517584,16.9073368 16.7389094,16.8007723 16.5654768,16.5515513 C16.4821643,16.4217827 16.4379563,16.2705371 16.4388073,16.1158286 L16.4388073,16.1158286 L16.4388073,11.5394755 L16.430517,11.4460452 C16.3869489,11.2035532 16.1768702,11.0195344 15.9244727,11.0195344 C15.6405256,11.0195344 15.4101382,11.2524331 15.4101382,11.5394755 L15.4101382,11.5394755 L15.4101382,16.1191287 L15.4019425,16.2343541 C15.3856442,16.3484782 15.3453164,16.4583731 15.2834687,16.5557094 C15.1100404,16.8040746 14.7971871,16.9115038 14.5098449,16.8195411 C14.2225027,16.7284452 14.0261097,16.4603146 14.0252609,16.1552318 L14.0252609,16.1552318 L14.0252609,11.5350974 L14.0169706,11.4416671 C13.9734025,11.199175 13.7633239,11.0151562 13.5109264,11.0151562 L13.5109264,11.0151562 Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'shop':
      return {
        path: 'M39.6253001,19.7893357 C39.4061361,31.2154218 29.2992923,42.4200896 20.9495179,49.6697849 C20.2900721,50.1100717 19.4114622,50.1100717 18.7520164,49.6697849 C9.96391393,41.9792568 -1.02183932,29.895929 0.0762341601,17.8105974 L0.0780876617,17.8126012 C1.17586157,8.1458388 9.30652199,0.455810823 19.192198,0.0154789496 C30.3968658,-0.424802829 39.6253001,8.58416689 39.6253001,19.7893357 Z M27.145494,14.9527992 L12.8545065,14.9527992 C12.4368657,14.9517946 12.08951,15.267251 12.0605628,15.6746939 L12.0605628,15.6746939 L11.0019711,30.1689156 C10.9864627,30.3842584 11.0629645,30.5965806 11.2138959,30.7532916 C11.3648246,30.911012 11.5757146,31.0009942 11.7959096,31 L11.7959096,31 L28.204091,31 C28.4242781,31.0009953 28.6351733,30.9110146 28.7861047,30.7532916 C28.937036,30.5965728 29.0135352,30.3842661 28.9980295,30.1689156 L28.9980295,30.1689156 L27.9394378,15.6746939 C27.9104853,15.2672251 27.5631349,14.951792 27.145494,14.9527992 L27.145494,14.9527992 Z M26.4073063,16.5057615 L27.3521788,29.4470309 L12.6478112,29.4470309 L13.5925249,16.5057615 L26.4073063,16.5057615 Z M22.2495023,9.5891707 C20.8569249,8.80358388 19.1429856,8.80363565 17.7504877,9.5891707 C16.5463688,10.2684375 15.7426552,11.4467888 15.5474099,12.7691063 C15.5173559,12.7923113 15.5009804,12.8173186 15.5009804,12.8433807 L15.5009804,12.8433807 L15.5009804,14.6033807 C15.5009804,14.7248354 15.8566143,14.8233807 16.2949242,14.8233807 C16.733234,14.8233807 17.0888679,14.7248354 17.0888679,14.6033807 L17.0888679,14.6033807 L17.0888679,13.3998569 C17.0888679,11.8276997 18.3924706,10.5527776 19.999995,10.5527776 C21.6075194,10.5527776 22.9111221,11.8276997 22.9111221,13.3998569 L22.9111221,13.3998569 L22.9111221,14.6033807 C22.9111221,14.7248354 23.2667559,14.8233807 23.7050658,14.8233807 C24.1433757,14.8233807 24.4990096,14.7248354 24.4990096,14.6033807 L24.4990096,14.6033807 L24.4990096,12.8433807 C24.4990096,12.8173186 24.4826341,12.7923113 24.4527568,12.769677 C24.2573533,11.4467235 23.4536898,10.2684822 22.2495023,9.5891707 Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'school':
      return {
        path: 'M39.6253001,19.7893357 C39.4061361,31.2154218 29.2992923,42.4200896 20.9495179,49.6697849 C20.2900721,50.1100717 19.4114622,50.1100717 18.7520164,49.6697849 C9.96391393,41.9792568 -1.02183932,29.895929 0.0762341601,17.8105974 C1.17586157,8.1458388 9.30652199,0.455810823 19.192198,0.0154789496 C30.3968658,-0.424802829 39.6253001,8.58416689 39.6253001,19.7893357 Z M19.7659839,12.0608614 C19.5985619,11.9797129 19.4010383,11.9797129 19.2336334,12.0608614 L19.2336334,12.0608614 L7.3289585,17.8321373 C6.89034717,18.0442254 6.89034717,18.6512037 7.3289585,18.8643526 L7.3289585,18.8643526 L11.7619271,21.0131529 L11.7619271,24.1184406 C11.7619271,24.3370101 11.8891421,24.5371711 12.0911427,24.6345483 L12.0911427,24.6345483 L14.7082399,25.9036972 C17.7261213,27.3654343 21.2748389,27.3654343 24.2915775,25.9036972 L24.2915775,25.9036972 L26.9086746,24.6345483 C27.1106638,24.5371601 27.2378902,24.3369991 27.2378902,24.1184406 L27.2378902,24.1184406 L27.2378902,21.0131529 L30.8091784,19.2819918 L30.8091784,22.9639639 C30.8091784,23.2831374 31.0759108,23.5417285 31.4040122,23.5417285 C31.7332307,23.5417285 32,23.2831346 32,22.9639639 L32,22.9639639 L32,18.3589061 C32.0010202,18.2691018 31.9809324,18.1760512 31.9362913,18.0894931 C31.9284802,18.0732618 31.9184348,18.0570332 31.9095066,18.0418848 L31.9095066,18.0418848 C31.845892,17.9445077 31.7588411,17.872015 31.6583993,17.8265727 L31.6583993,17.8265727 L31.6595164,17.8254897 L19.7659839,12.0608614 Z M26.0466514,21.5898928 L26.0466514,23.7625139 L23.7587984,24.8715373 C21.0771895,26.1709885 17.922085,26.1709885 15.2402761,24.8715373 L15.2402761,24.8715373 L12.9524232,23.7625139 L12.9524232,21.5898928 L19.2278337,24.6312743 C19.3907701,24.7124228 19.5894223,24.7199956 19.7657554,24.6345206 L19.7657554,24.6345206 L26.0466514,21.5898928 Z M19.5002801,13.2229553 L28.8827684,17.770508 L19.5002801,17.770508 C19.1710616,17.770508 18.9043321,18.0291019 18.9043321,18.3482727 C18.9043321,18.6663659 19.1710645,18.9249571 19.5002801,18.9249571 L19.5002801,18.9249571 L28.8827684,18.9249571 L26.3873237,20.1346094 C26.3802697,20.1378834 26.3724557,20.1411297 26.3657588,20.1454562 L26.3657588,20.1454562 L19.5000287,23.4737174 L12.6342985,20.1454562 C12.6264874,20.1411297 12.6197905,20.1378834 12.6119794,20.1346371 L12.6119794,20.1346371 L8.9269814,18.3483004 L19.5002801,13.2229553 Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'happy':
      return {
        path: 'M39.6253001,19.7893357 C39.4061361,31.2154218 29.2992923,42.4200896 20.9495179,49.6697849 C20.2900721,50.1100717 19.4114622,50.1100717 18.7520164,49.6697849 C9.96391393,41.9792568 -1.02183932,29.895929 0.0762341601,17.8105974 L0.0780876617,17.8126012 C1.17586157,8.1458388 9.30652199,0.455810823 19.192198,0.0154789496 C30.3968658,-0.424802829 39.6253001,8.58416689 39.6253001,19.7893357 Z M20,10 C14.3329603,10 10,14.3329608 10,20 C10,25.6670397 14.3329603,30 20,30 C25.6670392,30 30,25.6670397 30,20 C30,14.3337739 25.6670392,10 20,10 Z M19.9999998,11.3329404 C25.0001015,11.3329404 28.6669377,14.9997765 28.6669377,19.9998783 C28.6669377,24.99998 25.0001015,28.6668162 19.9999998,28.6668162 C14.999898,28.6668162 11.3330621,24.99998 11.3330621,19.9998783 C11.3330621,14.9997765 14.999898,11.3329404 19.9999998,11.3329404 Z M24.6673441,21.4998275 C23.3333671,24.8330931 16.6667341,24.8330931 15.3334685,21.4998275 L14.3337734,21.8333167 C16.3339361,26.4998479 23.6668359,26.4998479 25.6670392,21.8333167 L24.6673441,21.4998275 Z M16.8334177,16.6673037 C16.1886571,16.6673037 15.666978,17.1897755 15.666978,17.8337434 C15.666978,18.4777113 16.1894498,19.0001831 16.8334177,19.0001831 C17.4781784,19.0001831 17.9998574,18.4777113 17.9998574,17.8337434 C17.9998574,17.1897755 17.4773856,16.6673037 16.8334177,16.6673037 Z M23.1665818,16.6673037 C22.5226139,16.6673037 22.0001421,17.1897755 22.0001421,17.8337434 C22.0001421,18.4777113 22.5218212,19.0001831 23.1665818,19.0001831 C23.8113425,19.0001831 24.3330215,18.4777113 24.3330215,17.8337434 C24.3330215,17.1897755 23.8105497,16.6673037 23.1665818,16.6673037 Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'transport':
      return {
        path: 'M39.6253001,19.7893357 C39.4061361,31.2154218 29.2992923,42.4200896 20.9495179,49.6697849 C20.2900721,50.1100717 19.4114622,50.1100717 18.7520164,49.6697849 C9.96391393,41.9792568 -1.02183932,29.895929 0.0762341601,17.8105974 C1.17586157,8.1458388 9.30652199,0.455810823 19.192198,0.0154789496 C30.3968658,-0.424802829 39.6253001,8.58416689 39.6253001,19.7893357 Z M23.8834266,11 L16.1300567,11 C15.2875625,11.0101439 14.4792229,11.3389372 13.8625416,11.9221454 C13.2467136,12.5045097 12.8667038,13.2990343 12.7967093,14.1510726 L12.3667155,18.8302836 C11.0025578,19.0652503 10.0034133,20.2629552 10,21.6668051 L10,24.432354 C10,25.4576259 10.8191556,26.2884807 11.8299913,26.2884807 L12.6666615,26.2884807 L12.6666615,27.1404757 C12.6666615,28.1674354 13.4875024,29 14.5,29 C15.5125007,29 16.3333416,28.1674354 16.3333416,27.1404757 L16.3333416,26.2884807 L23.666659,26.2884807 L23.666659,27.1404757 C23.666659,28.1674354 24.4874999,29 25.5,29 C26.5124982,29 27.3333391,28.1674354 27.3333391,27.1404757 L27.3333391,26.2884807 L28.1700093,26.2884807 C28.6550002,26.2884807 29.1208339,26.0932326 29.4641718,25.7449998 C29.8075098,25.3967669 30,24.9242716 30,24.432354 L30,21.6668051 C29.9966656,20.2628687 28.9975062,19.0652719 27.6332851,18.8302836 L27.2168167,14.1577155 C27.148484,13.3048765 26.7693083,12.5086642 26.1526483,11.924677 C25.5359883,11.3406249 24.7268168,11.0109705 23.8834266,11 Z M15.0001413,26.2885023 L15.0001605,27.1404974 C15.0001605,27.4202763 14.7759903,27.6476481 14.5001413,27.6476481 C14.2243115,27.6476481 14.0001413,27.4202763 14.0001413,27.1404974 L14.0001413,26.2885023 L15.0001413,26.2885023 Z M26.0000108,26.2885023 L26.00003,27.1404974 C26.00003,27.4202763 25.7758598,27.6476481 25.5000108,27.6476481 C25.224181,27.6476481 25.0000108,27.4202763 25.0000108,27.1404974 L25.0000108,26.2885023 L26.0000108,26.2885023 Z M12.9801563,20.138604 L27.1633789,20.138604 C27.9942038,20.1402939 28.6667144,20.8240948 28.6667144,21.6667856 L28.6667144,24.4357511 C28.6667144,24.5692985 28.6141918,24.6977653 28.5208587,24.7915875 C28.4283597,24.8862537 28.3017018,24.93958 28.1700328,24.93958 L11.8368415,24.93958 C11.7035084,24.9411925 11.5751674,24.8887875 11.4801702,24.7932775 C11.3851714,24.6977653 11.3326702,24.5675934 11.3334849,24.4323561 L11.3334849,21.6668072 C11.3360044,21.2374233 11.5151696,20.827492 11.8276681,20.5375648 C12.1401667,20.2476377 12.5576719,20.1031177 12.9801563,20.138604 Z M14.4968656,20.7270031 C12.133564,20.8047656 12.1369773,24.2736827 14.4968656,24.3513631 C16.8567538,24.2736005 16.8567538,20.8014377 14.4968656,20.7270031 Z M25.5035617,20.7270031 C23.1436735,20.8047656 23.1436735,24.2769284 25.5035617,24.3513631 C27.8668633,24.2736005 27.86345,20.8014377 25.5035617,20.7270031 Z M14.4968655,22.0793762 C14.7468661,22.0793762 14.9501979,22.285612 14.9501979,22.5391831 C14.9501979,22.7927541 14.7468661,22.9989899 14.4968655,22.9989899 C14.2468608,22.9989899 14.0435332,22.7927541 14.0435332,22.5391831 C14.0435332,22.285612 14.246865,22.0793762 14.4968655,22.0793762 Z M25.5035617,22.0793762 C25.7535623,22.0793762 25.9568941,22.285612 25.9568941,22.5391831 C25.9568941,22.7927541 25.7535623,22.9989899 25.5035617,22.9989899 C25.2535569,22.9989899 25.0502294,22.7927541 25.0502294,22.5391831 C25.0502294,22.285612 25.2535612,22.0793762 25.5035617,22.0793762 Z M23.8700933,12.3522866 C24.9259203,12.3717283 25.7925851,13.2042816 25.8700889,14.2726564 L26.2734161,18.7861205 L13.7100299,18.7861205 L14.1135064,14.2659053 C14.1943404,13.1941551 15.0701763,12.3632786 16.1301634,12.3522866 L23.8700933,12.3522866 Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'bar':
      return {
        path: 'M22.48,21.81c-1.3,1.3-3.7,1.3-5,0-.6-.5-.9-1.1-1-1.9h7c-.1.7-.5,1.4-1,1.9ZM22.08,13.31h-4.2c-.9,2.6-1.4,4.1-1.4,5.5h7.1c-.1-1.4-.5-2.9-1.5-5.5ZM39.58,19.81c-.2,11.4-10.3,22.6-18.7,29.9-.7.4-1.5.4-2.2,0C9.98,42.01-1.02,29.91.08,17.81,1.18,8.11,9.28.51,19.18.01c11.2-.4,20.4,8.6,20.4,19.8ZM20.58,28.71v-4.7c1-.1,2-.6,2.8-1.3.9-.9,1.4-2.1,1.4-3.4,0-1.7-.4-3.5-1.7-6.9-.1-.2-.3-.4-.6-.4h-5c-.2,0-.5.2-.6.4-1.3,3.4-1.7,5.1-1.7,6.9,0,1.3.5,2.5,1.4,3.4.8.8,1.7,1.2,2.8,1.3v4.7h-2.7c-.3,0-.6.3-.6.6s.3.6.6.6h6.7c.3,0,.6-.3.6-.6s-.3-.6-.7-.6h-2.7Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'hair':
      return {
        path: 'M16.48,24.41c.3.3.5.7.5,1.2,0,1-.7,1.7-1.7,1.7-.9,0-1.7-.8-1.7-1.7s.8-1.7,1.7-1.7c.5,0,.9.2,1.2.5ZM15.28,14.61c-.9,0-1.7.8-1.7,1.7,0,1,.7,1.7,1.7,1.7s1.7-.8,1.7-1.7-.8-1.7-1.7-1.7ZM39.58,19.81c-.2,11.4-10.3,22.6-18.7,29.9-.7.4-1.5.4-2.2,0C9.98,42.01-1.02,29.91.08,17.81,1.18,8.11,9.28.51,19.18.01c11.2-.4,20.4,8.6,20.4,19.8ZM26.68,26.71l-4.1-4c-.3-.3-.7-.3-.9,0s-.3.7,0,.9l4,4c.1.1.3.2.5.2s.3-.1.5-.2c.3-.3.3-.7,0-.9ZM26.68,14.31c-.3-.2-.7-.3-.9,0l-5.8,5.8-2.2-2.2c.3-.5.5-1,.5-1.6,0-1.6-1.3-3-3-3s-3,1.3-3,3,1.3,3,3,3c.6,0,1.1-.2,1.6-.5l2.2,2.2-2.2,2.2c-.5-.3-1-.5-1.6-.5-1.6,0-3,1.3-3,3s1.3,3,3,3,3-1.3,3-3c0-.6-.2-1.1-.5-1.6l8.9-8.9c.3-.3.3-.7,0-.9Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'golf':
      return {
        path: 'M19.19.02C9.31.46,1.18,8.15.08,17.81h0c-1.1,12.08,9.89,24.17,18.68,31.86.66.44,1.54.44,2.2,0,8.35-7.25,18.46-18.45,18.68-29.88C39.63,8.58,30.4-.42,19.19.02ZM25.15,27.72c-.43.74-1.22,1.31-2.17,1.69-.96.39-2.1.59-3.25.59-1.15,0-2.29-.2-3.25-.58-.95-.38-1.75-.95-2.18-1.68-.46-.77-.46-1.63,0-2.41.43-.74,1.22-1.31,2.17-1.69.33-.13.71.03.85.36.13.33-.03.71-.36.85-.79.32-1.3.74-1.53,1.14-.21.36-.21.72,0,1.09.24.4.75.82,1.54,1.14.79.31,1.76.49,2.77.49,1.01,0,1.98-.18,2.76-.5.79-.32,1.3-.74,1.54-1.14.21-.36.21-.72,0-1.09-.24-.4-.75-.82-1.54-1.14-.33-.13-.5-.51-.36-.84s.51-.5.84-.36c.95.38,1.75.95,2.18,1.68.46.77.46,1.63,0,2.41ZM27.68,15.42l-7.31,3.66v7.27c0,.36-.29.65-.65.65s-.65-.29-.65-.65v-7.66s0,0,0-.01c0,0,0-.01,0-.02v-7.66c0-.23.12-.43.31-.55.19-.12.43-.13.63-.03l7.67,3.84c.22.11.36.34.36.58s-.14.47-.36.58Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'gym':
      return {
        path: 'M20.08,16.21l-5,5c-.4.4-1,.4-1.4,0-.2-.2-.3-.4-.3-.7s.1-.5.3-.7l1.4-1.4c.2-.2.2-.6,0-.8s-.6-.2-.8,0c-.1.1-.2.2-.3.2-.4.1-.8.1-1.1-.2-.1-.1-.2-.2-.2-.3s-.1-.2-.1-.4c0-.3.1-.5.3-.7l2.2-2.2c.3-.3.7-.4,1.1-.2.1,0,.2.1.3.2s.2.2.2.3.1.2.1.4c0,.1,0,.3-.1.4,0,.1-.1.2-.2.3-.2.2-.2.6,0,.8s.6.2.8,0l1.4-1.4c.4-.4,1-.4,1.4,0,.2.2.3.4.3.7s-.1.5-.3.7ZM25.58,24.51c-.2.2-.6.2-.8,0s-.2-.6,0-.8l1.4-1.4c.2-.2.3-.4.3-.7s-.1-.5-.3-.7c-.4-.4-1-.4-1.4,0l-5,5c-.2.2-.3.4-.3.7s.1.5.3.7c.4.4,1,.4,1.4,0l1.4-1.4c.2-.2.6-.2.8,0,.1.1.2.3.2.4s-.1.3-.2.4c-.2.2-.3.4-.3.7s.1.5.3.7c.4.4,1,.4,1.4,0l2.2-2.2c.2-.2.3-.4.3-.7s-.1-.5-.3-.7c-.4-.4-1-.4-1.4,0ZM39.58,19.81c-.2,11.4-10.3,22.6-18.7,29.9-.7.4-1.5.4-2.2,0C9.98,42.01-1.02,29.91.08,17.81,1.18,8.11,9.28.51,19.18.01c11.2-.4,20.4,8.6,20.4,19.8ZM27.18,27.41l.7-.7c.4-.4.6-1,.6-1.5s-.2-1.1-.6-1.5c-.2-.2-.5-.4-.9-.5.4-.4.6-1,.6-1.5,0-.6-.2-1.1-.6-1.5-.8-.8-2.3-.8-3.1,0l-2.1,2.1-3-3,2.2-2.3c.4-.4.6-1,.6-1.5,0-.6-.2-1.1-.6-1.5-.8-.8-2.3-.8-3.1,0q0-.1-.1-.2c-.1-.3-.3-.5-.5-.7-.2-.2-.4-.4-.7-.5-.8-.3-1.8-.1-2.4.5l-.7.7-.7-.7c-.2-.2-.6-.2-.8,0-.2.2-.2.6,0,.8l.7.7-.7.7c-.4.4-.6,1-.6,1.5,0,.3.1.6.2.8.1.3.3.5.5.7.2.2.5.4.9.5-.4.4-.6,1-.6,1.5,0,.6.2,1.1.6,1.5.4.4,1,.6,1.5.6s1.1-.2,1.5-.6l2.1-2.1,3,3-2.1,2.3c-.4.4-.6,1-.6,1.5,0,.6.2,1.1.6,1.5.8.8,2.3.8,3.1,0,.1.3.3.6.5.9.4.4,1,.6,1.5.6.6,0,1.1-.2,1.5-.6l.7-.7.7.7c.1.1.3.2.4.2s.3-.1.4-.2c.2-.2.2-.6,0-.8l-.6-.7Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'hotel':
      return {
        path: 'M12.28,18.31h2.1v6.3h-2.1v-6.3ZM26.68,18.31h-11.1v6.3h12.2v-5.2c0-.3-.1-.6-.3-.8-.2-.2-.5-.3-.8-.3ZM39.58,19.81c-.2,11.4-10.3,22.6-18.7,29.9-.7.4-1.5.4-2.2,0C9.98,42.01-1.02,29.91.08,17.81,1.18,8.11,9.28.51,19.18.01c11.2-.4,20.4,8.6,20.4,19.8ZM28.98,19.31c-.1-.6-.3-1.1-.7-1.6-.4-.4-1-.7-1.6-.7h-14.4v-2.7c0-.3-.3-.6-.6-.6s-.6.3-.6.6v13.3c0,.3.3.6.6.6s.6-.3.6-.6v-1.9h15.5v1.9c0,.3.3.6.6.6s.6-.3.6-.6v-8.3Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'pub':
      return {
        path: 'M24.78,16.51c-.4.4-1,.5-1.8.3-.4-.1-.8-.3-1.4-.3-.5,0-.8.1-1.1.2-.4.1-.7.2-1.4.2-.6,0-1-.1-1.4-.2-.3-.1-.7-.2-1.1-.2-.5,0-1,.1-1.4.3-.8.2-1.4.2-1.8-.3-.1-.1-.3-.5-.3-.9s.2-.8.4-1c.4-.4,1-.5,1.8-.3.4.1.8.2,1.3.2.6,0,1-.3,1.3-.7.4-.3.7-.6,1.2-.6s.8.3,1.1.6c.4.3.8.7,1.4.7.5,0,1-.1,1.4-.3.8-.2,1.3-.2,1.8.3.3.3.4.7.4,1s-.2.8-.4,1ZM24.98,20.81h-.2v3.8h.2c.5,0,.9-.2,1.3-.6.4-.3.6-.8.6-1.3s-.2-.9-.6-1.3c-.3-.4-.8-.6-1.3-.6ZM23.48,18.31l.1,9.4c0,.3-.1.6-.3.8-.2.2-.5.3-.8.3h-6.7c-.3,0-.6-.1-.8-.3-.2-.2-.3-.5-.3-.8v-9.4c.3,0,.6-.1.9-.2.3-.1.6-.2,1-.2.3,0,.5.1.8.1.4.1.9.3,1.7.3s1.3-.1,1.7-.3c.3-.1.5-.1.8-.1.4,0,.7.1,1,.2.3.1.6.2.9.2ZM18.08,21.01c0-.3-.3-.6-.6-.6s-.6.3-.6.6v5c0,.3.3.6.6.6s.6-.3.6-.6v-5ZM21.38,21.01c0-.3-.2-.6-.6-.6-.3,0-.6.3-.6.6v5c0,.3.3.6.6.6s.6-.3.6-.6v-5ZM39.58,19.81c-.2,11.4-10.3,22.6-18.7,29.9-.7.4-1.5.4-2.2,0C9.98,42.01-1.02,29.91.08,17.81,1.18,8.11,9.28.51,19.18.01c11.2-.4,20.4,8.6,20.4,19.8ZM28.08,22.71c0-.8-.3-1.6-.9-2.2-.6-.6-1.4-.9-2.2-.9h-.2v-1.5c.3-.1.6-.3.9-.6.5-.5.8-1.2.8-1.9s-.3-1.4-.8-1.9-1.2-.8-1.9-.8c-.4,0-.7.1-1.1.2-.3.1-.6.2-1,.2-.1,0-.3-.2-.6-.4-.4-.4-1-.9-1.9-.9-1,0-1.5.5-2,.9-.2.2-.4.4-.5.4-.3,0-.6-.1-1-.2-.4-.1-.7-.2-1.1-.2-.7,0-1.4.3-1.9.8s-.8,1.2-.8,1.9.3,1.4.8,1.9c.3.3.6.5.9.6v9.6c0,.6.2,1.2.7,1.6.4.4,1,.7,1.6.7h6.7c.6,0,1.2-.2,1.6-.7.4-.4.7-1,.7-1.6v-1.9h.1c.8,0,1.6-.3,2.2-.9s.9-1.4.9-2.2Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    case 'wellness':
      return {
        path: 'M21.8,18.4c0,2.02-1.15,3.81-1.8,4.66-.65-.85-1.8-2.64-1.8-4.66s1.15-3.81,1.8-4.66c.65.85,1.8,2.64,1.8,4.66ZM39.62,19.79c-.22,11.43-10.33,22.63-18.68,29.88-.66.44-1.54.44-2.2,0C9.96,41.98-1.02,29.9.08,17.81,1.18,8.15,9.31.46,19.19.02c11.2-.44,20.43,8.57,20.43,19.77ZM20.63,24.56c1.16-.13,3.71-.61,5.51-2.41,2.35-2.35,2.46-5.97,2.46-6.13s-.06-.32-.18-.44-.28-.19-.44-.18c-.07,0-1.83.05-3.69.85-.3.13-.44.48-.31.79s.49.45.79.31c.98-.42,1.95-.61,2.57-.69-.14,1.07-.59,3.17-2.05,4.63-1.18,1.18-2.79,1.7-3.92,1.93.73-1.09,1.63-2.83,1.63-4.82,0-3.3-2.46-5.91-2.57-6.02-.23-.24-.64-.24-.87,0-.1.11-2.57,2.72-2.57,6.02,0,1.99.9,3.73,1.63,4.82-1.14-.23-2.74-.75-3.92-1.93-1.45-1.45-1.91-3.56-2.05-4.63.62.08,1.58.27,2.57.69.31.13.66,0,.79-.31s0-.66-.31-.79c-1.86-.8-3.62-.85-3.69-.85-.16,0-.32.06-.44.18s-.18.27-.18.44c0,.15.11,3.77,2.46,6.13,1.8,1.8,4.34,2.28,5.51,2.41-.05.46-.24.99-.58,1.38-.39.44-.93.67-1.6.67-.41,0-.76-.14-1.18-.3-.76-.3-1.67-.65-3.07-.19.3-.74.72-1.26,1.27-1.6.28-.17.37-.54.2-.83-.17-.29-.54-.37-.83-.2-1.11.69-1.82,1.86-2.17,3.59-.05.23.05.47.24.6.19.14.44.15.65.03,1.64-.94,2.4-.64,3.28-.3.48.19.98.38,1.61.38,1.02,0,1.88-.37,2.5-1.07.11-.13.22-.27.31-.41.09.14.19.28.31.41.62.7,1.48,1.07,2.5,1.07.63,0,1.13-.19,1.62-.38.88-.34,1.64-.64,3.28.3.2.12.46.1.65-.03.19-.14.28-.37.24-.61-.35-1.73-1.05-2.91-2.17-3.59h0c-.28-.16-.65-.08-.83.21-.17.28-.09.65.2.83.55.34.97.87,1.27,1.6-1.4-.46-2.31-.11-3.07.19-.42.16-.77.3-1.18.3-.67,0-1.21-.22-1.6-.67-.35-.39-.53-.92-.58-1.38Z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
    default:
      return {
        path: 'M23.175.019C36.705-.51 47.848 10.3 47.848 23.747 47.583 37.46 35.38 50.904 25.297 59.604a2.42 2.42 0 0 1-2.654 0C12.032 50.375-1.234 35.875.093 21.373 1.42 9.775 11.237.547 23.174.019z',
        fillColor: color,
        fillOpacity: 1,
        strokeOpacity: 0,
        size: new google.maps.Size(42, 53),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(21, 53),
      };
  }
};

export default FlexibleMap;
